<template>
    <div>
        <v-card style="margin-top: 30px">
            <v-toolbar height="50px" card dark class="blue-grey darken-2 white--text">
                <v-toolbar-title color="white--text">Recibos</v-toolbar-title>
                <v-spacer></v-spacer>
                <!--<v-chip ma-3 label outline color="blue lighten-2">Rascunho</v-chip>-->
            </v-toolbar>
            <v-layout row wrap pa-2>
                <v-flex xs12 sm6 v-for="receiptItem in receipts" :key="receiptItem.id">
                    <receipt :receiptSingle="receiptItem"></receipt>
                </v-flex>

                <v-flex xs12 v-if="!receipts.length">
                    <span class="text-xs-center" style="padding-left: 5px">Nenhum recibo foi gerado ainda para essa factura</span>
                </v-flex>
            </v-layout>
        </v-card>

        <v-card v-if="deletedReceipts.length > 0" style="margin-top: 30px">
            <v-toolbar height="50px" card dark color="red lighten-2">
                <v-toolbar-title color="white--text">Recibos anulados</v-toolbar-title>
                <v-spacer></v-spacer>
                <!--<v-chip ma-3 label outline color="blue lighten-2">Rascunho</v-chip>-->
            </v-toolbar>
            <v-layout row wrap pa-2>
                <v-flex xs12 sm6 v-for="deletedReceiptItem in deletedReceipts" :key="deletedReceiptItem.id">
                    <receipt :receiptSingle="deletedReceiptItem"></receipt>
                </v-flex>

                <!-- <v-flex xs12 v-if="!receipts.length">
                    <span class="text-xs-center" style="padding-left: 5px">Nenhum recibo anulado</span>
                </v-flex> -->
            </v-layout>
        </v-card>

        <!--Receipt Paper-->
        <receipt-paper :isA5Format="isA5Format"></receipt-paper>
    </div>

</template>

<script>
    import Receipt from './Receipt';
    import ReceiptPaper from '../receipt/ReceiptPaper';

    export default {
        name: "ReceiptContainer",

        components:{
            Receipt,
            ReceiptPaper,
        },

        props:['receipts', 'deletedReceipts', 'isA5Format'],

    }
</script>

<style scoped>

</style>